import React from 'react';
import './AboutSpecialties.css';

const AboutSpecialties = ({ settings = {} }) => {
  console.log('AboutSpecialties component loading...', settings);
  
  const {
    title = 'UNSERE SPEZIALITÄTEN',
    intro = 'Ob Mezze, Grillspezialitäten, vegetarische Teller, Teigtaschen, Falafel, Hummus, Fatayer, Spaghetti, Pizza, Fladenbrot oder Tabbouleh - wir verwöhnen Sie mit unseren aussergewöhnlichen aber köstlichen Gerichten aus dem fernen Osten.',
    highlights = [],
    background_color = '#ffffff',
    background_image = '',
    text_color = '#333333',
    accent_color = '#4A90E2'
  } = settings;

  const backgroundStyle = background_image 
    ? { 
        background: `url(${background_image}) center/cover no-repeat`,
        backgroundColor: background_color,
        color: text_color
      }
    : { 
        backgroundColor: background_color, 
        color: text_color 
      };

  return (
    <section className="about-specialties" style={backgroundStyle}>
      <div className="about-specialties__container">
        <div className="about-specialties__header">
          <h2 className="about-specialties__title" style={{ color: accent_color }}>
            {title}
          </h2>
          <p className="about-specialties__intro">
            {intro}
          </p>
        </div>

        <div className="about-specialties__highlights">
          <h3 className="about-specialties__subtitle" style={{ color: accent_color }}>
            Unsere Highlights:
          </h3>
          <div className="about-specialties__grid">
            {highlights.map((highlight, index) => (
              <div key={index} className="about-specialties__item">
                <div className="about-specialties__item-icon" style={{ backgroundColor: accent_color }}>
                  {highlight.icon || '•'}
                </div>
                <div className="about-specialties__item-content">
                  <h4 className="about-specialties__item-title" style={{ color: accent_color }}>
                    {highlight.title}
                  </h4>
                  <p className="about-specialties__item-description">
                    {highlight.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSpecialties;